export default "__VITE_ASSET__t4OHIuow__"